import * as React from 'react';
import { createStyles, withStyles } from '@material-ui/core';
import { formatOpenHouse } from '../../../lib/helpers';

interface Props {
  classes: any;
  listing: any;
  paddingTop?: boolean;
}

const styles = createStyles({
  openHouseContainer: {
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.75)',
    borderRadius: 3,
    display: 'flex',
    height: 25,
    justifyContent: 'center',
  },
  openHouseText: {
    color: '#FFFFFF',
    fontSize: 12,
    fontWeight: 'bold',
    paddingLeft: 10,
    paddingRight: 10,
  },
});

export const OpenHouse = (props: Props) => {
  const { classes, listing, paddingTop } = props;
  const openHouseOrUpdate = formatOpenHouse(listing);
  const marginStyle = paddingTop ? { marginTop: 5 } : { marginLeft: 5 };
  return (
    <div className={classes.openHouseContainer} style={marginStyle}>
      <p className={classes.openHouseText}>{openHouseOrUpdate}</p>
    </div>
  );
};

export default withStyles(styles)(OpenHouse);
